module.exports = __webpack_public_path__ + "img/twitter.a892b26.png";